import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ukFlag from './assets/uk.png';
import myFlag from './assets/my.png';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', name: 'English', flag: ukFlag },
    { code: 'ms', name: 'Malay', flag: myFlag }
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  // Don't show language switcher on admin pages
  if (location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg text-gray-700 hover:bg-gray-200 hover:text-primary transition-all duration-200 text-sm font-medium whitespace-nowrap min-w-max border border-gray-200"
      >
        <span className="whitespace-nowrap flex items-center gap-2">
          <img src={currentLanguage.flag} alt={`${currentLanguage.name} flag`} className="w-4 h-3 object-cover rounded-sm" />
          <span>{currentLanguage.name}</span>
        </span>
        <svg 
          className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {isOpen && (
        <div className="absolute top-full left-0 mt-1 min-w-full bg-white rounded-lg shadow-lg border border-gray-200 z-50">
          {languages.map((language) => (
            <button
              key={language.code}
              onClick={() => changeLanguage(language.code)}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-100 transition-colors duration-200 first:rounded-t-lg last:rounded-b-lg whitespace-nowrap min-w-max flex items-center gap-3 ${
                language.code === i18n.language 
                  ? 'bg-primary text-white hover:bg-primary/90' 
                  : 'text-gray-700'
              }`}
            >
              <img src={language.flag} alt={`${language.name} flag`} className="w-4 h-3 object-cover rounded-sm" />
              <span>{language.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
